"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const configureStore_1 = require("./store/configureStore");
const Modal = () => {
    const { handleIsModal, modalContents } = (0, react_1.useContext)(configureStore_1.StoreContext);
    const closeModal = () => {
        handleIsModal(false);
    };
    return (react_1.default.createElement("article", { style: {
            position: "absolute",
            display: "flex",
            flexFlow: "column",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            background: "rgb(0,0,0, 0.5)",
            zIndex: 99999999,
        }, onClick: closeModal },
        react_1.default.createElement("div", { "data-testid": "modal-box", style: {
                display: "flex",
                flexFlow: "column wrap",
                justifyContent: "center",
                minWidth: "50%",
                minHeight: "30%",
                margin: "0 auto",
                background: "#bb5f5f",
                borderRadius: "3px",
            } }, modalContents)));
};
exports.default = Modal;
